import { HTTP_TOKEN } from "./http";

export const getPipelines = () => {
  return HTTP_TOKEN.get("pipeline").then((result) => {
    return result.data;
  });
};

export const getPipeline = (pipeline_id) => {
  return HTTP_TOKEN.get(`pipeline/${pipeline_id}`).then((result) => {
    return result.data;
  });
};

export const createPipeline = (data) => {
  return HTTP_TOKEN.post("pipeline", data).then((result) => {
    return result.data;
  });
};

export const updatePipeline = (pipeline_id, data) => {
  return HTTP_TOKEN.put(`pipeline/${pipeline_id}`, data).then((result) => {
    return result.data;
  });
};

export const deletePipeline = (pipeline_id) => {
  return HTTP_TOKEN.delete(`pipeline/${pipeline_id}`).then((result) => {
    return result.data;
  });
};

// Deals (Negócios)
export const createDeal = (data) => {
  return HTTP_TOKEN.post("pipeline/deal", data).then((result) => {
    return result.data;
  });
};

export const updateDeal = (deal_id, data) => {
  return HTTP_TOKEN.put(`pipeline/deal/${deal_id}`, data).then((result) => {
    return result.data;
  });
};

export const deleteDeal = (deal_id) => {
  return HTTP_TOKEN.delete(`pipeline/deal/${deal_id}`).then((result) => {
    return result.data;
  });
};

export const getPipelineUsers = () => {
  return HTTP_TOKEN.get("pipeline/users").then((result) => {
    return result.data;
  });
};

export const getStepDeals = (pipeline_id, step_id, page) => {
  return HTTP_TOKEN.get(`pipeline/${pipeline_id}/step/${step_id}/deals`, {
    params: { page }
  }).then((result) => {
    return result.data;
  });
};
